import React, { useState } from "react"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import Link from "next/link"
import { useTranslation } from "next-i18next"
import Image from "next/image"
import ArrowDown1 from "@/common/assets/image/ui/ArrowDown1.svg"
import ArrowDown2 from "@/common/assets/image/ui/ArrowDown2.svg"

export default function BlogMenu({ Data, tab, setTab, search, onChange }) {
  const { t } = useTranslation("common")
  const [toggle, setToggle] = useState(false)
  const btnToggle = () => {
    setToggle(!toggle)
  }
  return (
    <Wrapper>
      <TagTitle onClick={btnToggle}>
        <div className="tagTitle">{t(tab)}</div>
        <ImageWrapper className={toggle === true ? "show" : ""}>
          <Image
            src={ArrowDown1}
            alt="Down"
            fill
            sizes="100vw"
            style={{
              objectFit: "cover"
            }}
          />
          <Image
            src={ArrowDown2}
            alt="Down"
            fill
            sizes="100vw"
            style={{
              objectFit: "cover"
            }}
          />
        </ImageWrapper>
      </TagTitle>
      <ContentWrapper className={toggle === true ? "show" : ""}>
        <Link href="#All" passHref legacyBehavior>
          <span
            className={tab === "All" ? "tag active" : "tag"}
            onClick={() => {
              onChange()
              search("All")
              setTab("All")
            }}
          >
            {t("tag-all")}
          </span>
        </Link>
        {Data.map(({ id }) => (
          <Link href={`#${id}`} key={id} passHref legacyBehavior>
            <span
              className={tab === id ? "tag active" : "tag"}
              onClick={() => {
                onChange()
                search(t(id))
                setTab(id)
              }}
            >
              {t(id)}
            </span>
          </Link>
        ))}
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: calc(100% - 300px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 1024px) {
    width: 100%;
    order: 2;
  }
  @media (max-width: 768px) {
    border-radius: 20px;
    border: 0.5px solid ${themeGet("colors.primary")};
  }
`

const TagTitle = styled.div`
  display: none;
  @media (max-width: 768px) {
    cursor: pointer;
    flex: 1 1 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin: 4px 18px 4px 12px;
    height: 30px;
    transition: 0.3s;
    color: #fff;
    font-weight: 500;
    opacity: 1;
    .tagTitle {
      &:before {
        content: "#";
      }
    }
    &:hover {
      color: ${themeGet("colors.primary")};
      span {
        opacity: 0 !important;

        &:nth-child(2) {
          opacity: 1 !important;
        }
      }
    }
  }
`
const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  transition: all 0.3s;
  gap: 8px;
  .tag {
    cursor: pointer;
    padding: 4px 12px 4px 12px;
    height: 30px;
    border: 0.2px solid ${themeGet("colors.primary")}00;
    border-radius: 16px;
    transition: 0.3s;
    color: #fff;
    font-weight: 500;
    opacity: 0.8;
    &:before {
      content: "#";
    }
    &.active {
      color: ${themeGet("colors.primary")};
      opacity: 1;
      border: 0.2px solid ${themeGet("colors.primary")};
      @media (max-width: 768px) {
        border: 0.2px solid ${themeGet("colors.primary")}00;
      }
    }
    &:hover {
      color: ${themeGet("colors.primary")};
    }
  }
  @media (max-width: 768px) {
    overflow: hidden;
    height: 0;

    &.show {
      padding: 8px 0;
      border-top: 0.2px solid ${themeGet("colors.primary")}80;
      height: 130px;
      overflow: scroll;

      /* 這邊設置拉桿css */
      ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: none;
      }

      ::-webkit-scrollbar {
        width: 4px;
        background-color: none;
      }

      ::-webkit-scrollbar-thumb {
        background: linear-gradient(#ffc411, #ffebaf);
        border-radius: 5px;
      }
      ::-webkit-scrollbar-corner {
        border: none;
      }
    }
  }
`

const ImageWrapper = styled.div`
  position: relative;
  width: 16px;
  height: 16px;
  transition: 0.3s;
  span {
    opacity: 0 !important;
    transition: 0.3s;
    &:nth-child(1) {
      opacity: 1 !important;
    }
  }
  &.show {
    rotate: -180deg;
  }
`
